define('app/sdc/stop/md/gesture/propagation/sdc-stop-md-gesture-propagation',["factory!sdc-stop-propagation"], function (stopPropagation) {
	return {
		restrict: "EA",
		scope: false,
		template: null,
		controller: null,
		link: ["$scope", "$element", function ($scope, $element) {
			stopPropagation($element, "$md.pressdown $md.pressup $md.dragstart $md.drag $md.dragend").scope($scope);
		}]
	};
});
